// components

const casesArr = [
    {
        id: 1,
        type: "Mojito",
        title: "Spear-mint, Lime",
        p: "Crisp lime and subtle mint dance together perfectly in this OG cocktail inspired flavor.",
        img: "https://www.drinkkove.com/wp-content/themes/kove/assets/video/mojito_v2.mp4",
        bg: "#CBDBB9",
        ing: "Filtered Water, Cane sugar, Yerba Mate, Spearmint, Lime, Lime Oil, Yeast, Yeast Nutrient",
    },
    {
        id: 2,
        type: "Passion Berry",
        title: "Passion fruit, Blackberry",
        p: "Tart passion fruit blended with sweet blackberries truly makes the perfect pairing.",
        img: "https://www.drinkkove.com/wp-content/themes/kove/assets/video/berry_v2.mp4",
        bg: "#DCD4D9",
        ing: "Filtered Water, Cane sugar, Yerba Mate, Passion Fruit, Blackberry, Yeast, Yeast Nutrient",
    },
    {
        id: 3,
        type: "Mango Colada",
        title: "Mango, Orange, Coconut",
        p: "Mango fruit blended with a bliss of Coconut truly makes you feel in summer.",
        img: "https://www.drinkkove.com/wp-content/themes/kove/assets/video/Mango_v5-2.mp4",
        bg: "#F7E29B",
        ing: "Filtered Water, Mango sugar, Yerba Mate, Coconut, Lemon Oil, Yeast, Yeast Nutrient",
    },
    {
        id: 4,
        type: "Lemon Iced-Tea",
        title: "Black tea, Lemon",
        p: "Tangy lemon citrus is paired with sweet and rich black tea in this nostalgic Albatross of a blend. Truly a Hole-In-One.",
        img: "https://www.drinkkove.com/wp-content/themes/kove/assets/video/lemon_v2.mp4",
        bg: "#EBE9AF",
        ing: "Filtered Water, Cane sugar, Yerba Mate, Black Tea, Lemon Oil, Yeast, Yeast Nutrient",
    },
];

export default casesArr;
